import { useRef, useEffect, useMemo } from 'react';

import { useAuth } from '../../context/AuthContext';
import { useStreamingDispatchers, useStreamingSelectors, useChatDispatchers, useChatSelectors } from '../../pages/usePlanningPageState';

export const useChatBoxState = () => {
  // 1. Redux State Access
  const chatSelectors = useChatSelectors();

  const chatDispatchers = useChatDispatchers();
  const chatState = useMemo(() => ({ ...chatSelectors, ...chatDispatchers }), [chatSelectors, chatDispatchers]);

  const streamingSelectors = useStreamingSelectors();

  const isAiTypingRef = useRef(streamingSelectors.isAiTyping);
  const streamingDisplayRef = useRef(streamingSelectors.streamingDisplay);

  useEffect(() => { isAiTypingRef.current = streamingSelectors.isAiTyping; }, [streamingSelectors.isAiTyping]);

  const streamingDispatchers = useStreamingDispatchers({ isAiTypingRef, streamingDisplayRef });
  const streamingState = useMemo(() => ({ ...streamingSelectors, ...streamingDispatchers }),
    [streamingSelectors, streamingDispatchers]);

    interface ExtendedUser {
        full_name?: string;
        displayName?: string;
        email?: string;
    }

    const { user } = useAuth();
    const u = user as unknown as ExtendedUser;
    const userDisplayName = u?.full_name || u?.displayName || u?.email || 'You';

    return { chatState, streamingState, userDisplayName, chatSelectors, streamingSelectors };
};
